module.exports = __webpack_public_path__ + "img/review.b157c413.svg";